import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CircCommonModule } from "../common";
import { KendoModule } from "../kendo/kendo.module";
import { AdminEditComponent } from "./components/admin/admin-edit.component";
import { AdminGridComponent } from "./components/admin/admin-grid.component";
import { AdminNewComponent } from "./components/admin/admin-new.component";
import { AdminViewComponent } from "./components/admin/admin-view.component";
import { SharedEditComponent } from "./components/shared/shared-edit.component";
import { UserViewComponent } from "./components/user/user-view.component";
import { SubstitutesRoutingModule } from "./substitute-routing.module";

@NgModule({
  declarations: [
    AdminGridComponent,
    AdminViewComponent,
    AdminEditComponent,
    UserViewComponent,
    SharedEditComponent,
    AdminNewComponent
  ],
  imports: [
    CommonModule,
    CircCommonModule,
    KendoModule,
    SubstitutesRoutingModule
  ],
  exports: []
})
export class SubstituteModule {}
